import 'canvas-toBlob'
export class ImageUtils
{
    static async getBlob(canvas: HTMLCanvasElement, type: string = 'image/jpeg', quality: number = 1) {
        return new Promise<Blob | null>(resolve => {
            canvas.toBlob(blob => {
                resolve(blob)
            }, type, quality)
        })
    }
}



// WEBPACK FOOTER //
// ./src/utils/ImageUtils.ts